<div class="" [class.tw]="!istalWindCssHide">

  @if(!isLoggedIn && !hideHeader && !hideSidebar){
  <app-document-sidebar></app-document-sidebar>
  }

  <!-- Main Content -->
  <div id="main-content" class="transition-all duration-300 " [class.lg:ml-64]="!isLoggedIn && !hideHeader && !hideSidebar" role="main">

    @if(!isLoggedIn && !hideHeader){
    <app-header />
    }

    <!-- Page Content -->
    <main class="" [class.p-4]="!isLoggedIn && !hideHeader" [class.sm:p-6]="!isLoggedIn && !hideHeader"
      [class.lg:p-8]="!isLoggedIn && !hideHeader">
      <div name="content">
        <router-outlet />
      </div>
    </main>


  </div>

  <!-- Search Modal -->
  <div id="search-modal" class="hidden fixed inset-0 z-50">
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" (click)="closeSearchModal()"></div>
    <div class="fixed top-20 left-1/2 -translate-x-1/2 w-full max-w-xl mx-4">
      <div
        class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl border border-gray-200 dark:border-slate-700 overflow-hidden">
        <div class="flex items-center px-4 border-b border-gray-100 dark:border-slate-700">
          <i class="fas fa-search text-gray-400 mr-3"></i>
          <input type="text" id="search-input" placeholder="{{ 'COMMON.SEARCH_PLACEHOLDER' | translate }}"
            class="flex-1 py-4 bg-transparent text-gray-900 dark:text-white placeholder-gray-400 outline-none text-base"
            autofocus>
          <span class="text-xs text-gray-400 bg-gray-100 dark:bg-slate-700 px-2 py-1 rounded font-mono">{{
            'COMMON.ESCAPE'
            | translate }}</span>
        </div>
        <!-- <div class="p-2 max-h-80 overflow-y-auto">
          <p class="px-3 py-2 text-xs font-semibold text-gray-400 uppercase">{{ 'COMMON.QUICK_ACTIONS' | translate }}</p>
          <a href="#" class="flex items-center px-3 py-2.5 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 text-gray-700 dark:text-gray-300">
          <div class="w-8 h-8 bg-indigo-100 dark:bg-indigo-900/30 rounded-lg flex items-center justify-center mr-3">
              <i class="fas fa-plus text-indigo-600 dark:text-indigo-400 text-sm"></i>
          </div>
          <span class="text-sm">{{ 'COMMON.CREATE_NEW_ENVELOPE' | translate }}</span>
          <span class="ml-auto text-xs text-gray-400">⌘N</span>
          </a>
          <a href="#" class="flex items-center px-3 py-2.5 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 text-gray-700 dark:text-gray-300">
          <div class="w-8 h-8 bg-green-100 dark:bg-green-900/30 rounded-lg flex items-center justify-center mr-3">
              <i class="fas fa-user-plus text-green-600 dark:text-green-400 text-sm"></i>
          </div>
          <span class="text-sm">{{ 'COMMON.ADD_RECIPIENT' | translate }}</span>
          <span class="ml-auto text-xs text-gray-400">⌘R</span>
          </a>
          <a href="#" class="flex items-center px-3 py-2.5 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 text-gray-700 dark:text-gray-300">
          <div class="w-8 h-8 bg-purple-100 dark:bg-purple-900/30 rounded-lg flex items-center justify-center mr-3">
              <i class="fas fa-file-upload text-purple-600 dark:text-purple-400 text-sm"></i>
          </div>
          <span class="text-sm">{{ 'COMMON.UPLOAD_DOCUMENT' | translate }}</span>
          <span class="ml-auto text-xs text-gray-400">⌘U</span>
          </a>
      </div> -->
      </div>
    </div>
  </div>

  <!-- Keyboard Shortcuts Modal -->
  @if (isShortcutsOpen) {
  <div class="fixed inset-0 z-50" role="dialog" aria-modal="true" aria-labelledby="shortcuts-title">

    <!-- Overlay -->
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" (click)="closeKeyboardShortcuts()">
    </div>

    <!-- Modal -->
    <div class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg mx-4">
      <div
        class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl border border-gray-200 dark:border-slate-700 overflow-hidden bounce-in">

        <!-- Header -->
        <div class="flex items-center justify-between px-6 py-4 border-b border-gray-100 dark:border-slate-700">
          <h2 id="shortcuts-title" class="text-lg font-semibold text-gray-900 dark:text-white">
            {{ 'COMMON.KEYBOARD_SHORTCUTS' | translate }}
          </h2>

          <button (click)="closeKeyboardShortcuts()"
            class="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:bg-slate-700"
            [attr.aria-label]="'COMMON.CLOSE' | translate">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- Body -->
        <div class="p-6 max-h-96 overflow-y-auto">

          <!-- Navigation -->
          <div class="mb-6">
            <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">
              {{ 'COMMON.NAVIGATION' | translate }}
            </h3>

            <div class="space-y-2">
              <div class="flex justify-between py-2">
                <span>{{ 'COMMON.OPEN_SEARCH' | translate }}</span>
                <span class="kbd">⌘ K</span>
              </div>

              <div class="flex justify-between py-2">
                <span>{{ 'COMMON.GO_TO_DASHBOARD' | translate }}</span>
                <span class="kbd">G D</span>
              </div>

              <div class="flex justify-between py-2">
                <span>{{ 'COMMON.GO_TO_ENVELOPES' | translate }}</span>
                <span class="kbd">G E</span>
              </div>

              <div class="flex justify-between py-2">
                <span>{{ 'COMMON.GO_TO_SETTINGS' | translate }}</span>
                <span class="kbd">G S</span>
              </div>
            </div>
          </div>

          <!-- Actions -->
          <div class="mb-6">
            <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">
              {{ 'COMMON.ACTIONS' | translate }}
            </h3>

            <div class="space-y-2">
              <div class="flex justify-between py-2">
                <span>{{ 'COMMON.CREATE_ENVELOPE' | translate }}</span>
                <span class="kbd">⌘ N</span>
              </div>

              <div class="flex justify-between py-2">
                <span>{{ 'COMMON.UPLOAD_DOCUMENT' | translate }}</span>
                <span class="kbd">⌘ U</span>
              </div>

              <div class="flex justify-between py-2">
                <span>{{ 'COMMON.TOGGLE_SIDEBAR' | translate }}</span>
                <span class="kbd">⌘ \</span>
              </div>
            </div>
          </div>

          <!-- General -->
          <div>
            <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">
              {{ 'COMMON.GENERAL' | translate }}
            </h3>

            <div class="space-y-2">
              <div class="flex justify-between py-2">
                <span>{{ 'COMMON.TOGGLE_DARK_MODE' | translate }}</span>
                <span class="kbd">⌘ D</span>
              </div>

              <div class="flex justify-between py-2">
                <span>{{ 'COMMON.SHOW_SHORTCUTS' | translate }}</span>
                <span class="kbd">?</span>
              </div>

              <div class="flex justify-between py-2">
                <span>{{ 'COMMON.CLOSE_MODAL' | translate }}</span>
                <span class="kbd">{{ 'COMMON.ESCAPE' | translate }}</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
  }

  <!-- New build update popup — cannot be dismissed -->
  @if (showUpdatePopup()) {
  <div class="fixed inset-0 z-[80] flex items-end sm:items-center justify-center p-4 sm:p-6"
    role="alertdialog" aria-modal="true" aria-labelledby="app-update-title" aria-describedby="app-update-message">

    <div class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm"></div>

    <div class="relative w-full max-w-md bounce-in">
      <div
        class="overflow-hidden rounded-2xl border border-indigo-100 bg-white shadow-2xl dark:border-slate-700 dark:bg-slate-800">

        <div class="h-1.5 w-full bg-indigo-100 dark:bg-slate-700">
          <div class="app-update-progress-bar h-full bg-indigo-600"></div>
        </div>

        <div class="px-5 py-6 sm:px-7 sm:py-8 text-center">
          <div
            class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-indigo-100 dark:bg-indigo-900/40">
            <i class="fas fa-sync-alt app-update-icon text-xl text-indigo-600 dark:text-indigo-400"></i>
          </div>

          <h2 id="app-update-title" class="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white mb-2">
            {{ 'COMMON.APP_UPDATE_TITLE' | translate }}
          </h2>

          <p id="app-update-message" class="text-sm leading-relaxed text-gray-600 dark:text-gray-300 mb-2">
            {{ 'COMMON.APP_UPDATE_MESSAGE' | translate }}
          </p>

          <p class="text-sm font-medium text-indigo-600 dark:text-indigo-400 mb-6">
            {{ 'COMMON.APP_UPDATE_COUNTDOWN' | translate:{ seconds: refreshCountdown() } }}
          </p>

          <button type="button" (click)="hardRefresh()"
            class="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-indigo-600 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:focus:ring-offset-slate-800">
            <i class="fas fa-redo-alt text-xs"></i>
            {{ 'COMMON.APP_UPDATE_REFRESH' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Toast Container -->
  <div id="toast-container" class="fixed top-4 right-4 z-50 space-y-2" aria-live="polite" aria-label="Notifications">
  </div>


  <ngx-ui-loader bgsColor="#122589" fgsColor="#104cb0" fgsType="ball-spin-clockwise"></ngx-ui-loader>
</div>